import axios from "axios";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import React, { useEffect, useState } from "react";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../utils/consts";
import Notification from "../../notification/Notification";
import { parseAxiosError } from "../../../../utils/response";
import CurrencySelect from "./CurrencySelect";
import PaymentSystemSelect from "./PaymentSystemSelect";
import ServiceSelect from "./ServiceSelect";
import { fetchFilterData } from "../../../../utils/fetchFilterData";

const MappedServicesFilter = ({
  checkedService,
  checkedCurrency,
  checkedPaymentSystem,
  setCheckedService,
  setCheckedCurrency,
  setCheckedPaymentSystem,
  withPaymentSystem = true,
  withCurrency = true,
  rateService = false,
  withoutCurrencyType = null
}) => {
  const [mappedData, setMappedData] = useState(null);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: "Currency"
  });

  const fetchServiceRelationships = () => {
    const filterData = { rateService, withPaymentSystem, withCurrency, withoutCurrencyType };

    axios.get("/api/service-relationships/get-mapped" + fetchFilterData(filterData), userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setMappedData(response.data);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    fetchServiceRelationships();
  }, []);

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <ServiceSelect
        mappedData={mappedData}
        checkedService={checkedService}
        setCheckedService={setCheckedService}
        setCheckedCurrency={withCurrency ? setCheckedCurrency : null}
        setCheckedPaymentSystem={withPaymentSystem ? setCheckedPaymentSystem : null}
      />
      {withPaymentSystem &&
        <PaymentSystemSelect
          checkedService={checkedService}
          checkedPaymentSystem={checkedPaymentSystem}
          setCheckedPaymentSystem={setCheckedPaymentSystem}
          mappedData={mappedData}
        />
      }
      {withCurrency &&
        <CurrencySelect
          checkedService={checkedService}
          checkedCurrency={checkedCurrency}
          setCheckedCurrency={setCheckedCurrency}
          mappedData={mappedData}
        />
      }
    </>
  );
};

export default MappedServicesFilter;